(function () {
  'use strict';

  var ROOT_SELECTOR = 'eme-pdp';
  var OPENER_SELECTOR = '[data-eme-open-zoom]';

  function mediaIndexFromSlide(slide) {
    var element = slide && slide.data && slide.data.element;
    if (!element) return null;
    var index = Number(element.dataset.emeOpenZoom);
    return Number.isFinite(index) ? index : null;
  }

  function syncProductGallery(root, mediaIndex) {
    if (mediaIndex === null) return;

    var gallery = root.querySelector('[data-eme-images]');
    var media = root.querySelector('[data-eme-open-zoom="' + mediaIndex + '"]');

    if (gallery && media) {
      if (window.matchMedia('(min-width: 1025px)').matches) {
        gallery.scrollTop = Math.max(
          0,
          media.offsetTop - ((gallery.clientHeight - media.offsetHeight) / 2)
        );
      } else {
        gallery.scrollLeft = Math.max(
          0,
          media.offsetLeft - ((gallery.clientWidth - media.offsetWidth) / 2)
        );
      }
    }

    if (typeof root.setActive === 'function') root.setActive(mediaIndex);
  }

  function initialize(root) {
    if (!root || root._emeZoomLightbox || !root.querySelector(OPENER_SELECTOR)) return;
    if (typeof window.PhotoSwipeLightbox !== 'function' || typeof window.PhotoSwipe !== 'function') return;

    var lastViewedMediaIndex = null;
    var lastOpener = null;
    var inertElements = [];

    var rememberOpener = function (event) {
      var opener = event.target.closest && event.target.closest(OPENER_SELECTOR);
      if (opener && root.contains(opener)) lastOpener = opener;
    };

    var setBackgroundInert = function (viewer) {
      inertElements = [];
      Array.from(document.body.children).forEach(function (element) {
        if (element === viewer || element.contains(viewer) || element.hasAttribute('inert')) return;
        element.setAttribute('inert', '');
        inertElements.push(element);
      });
    };

    var restoreBackground = function () {
      inertElements.forEach(function (element) { element.removeAttribute('inert'); });
      inertElements = [];
      document.documentElement.classList.remove('eme-pswp-open');
    };

    var trapFocus = function (event) {
      if (event.key !== 'Tab') return;

      var viewer = event.currentTarget;
      var focusable = Array.from(viewer.querySelectorAll('button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])'))
        .filter(function (element) {
          var style = window.getComputedStyle(element);
          return element.tabIndex >= 0 &&
            element.getClientRects().length > 0 &&
            style.display !== 'none' &&
            style.visibility !== 'hidden' &&
            style.pointerEvents !== 'none' &&
            Number(style.opacity) > 0 &&
            !element.closest('[aria-hidden="true"]');
        });

      if (!focusable.length) {
        event.preventDefault();
        viewer.focus({ preventScroll: true });
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      var active = document.activeElement;

      if (!viewer.contains(active)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus({ preventScroll: true });
      } else if (event.shiftKey && active === first) {
        event.preventDefault();
        last.focus({ preventScroll: true });
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus({ preventScroll: true });
      }
    };

    root.addEventListener('click', rememberOpener, true);
    var lightbox = new window.PhotoSwipeLightbox({
      gallery: root,
      children: OPENER_SELECTOR,
      pswpModule: window.PhotoSwipe,
      mainClass: 'eme-pswp',
      loop: false,
      bgOpacity: 1,
      showHideAnimationType: 'zoom',
      wheelToZoom: true,
      mouseMovePan: true,
      pinchToClose: true,
      closeOnVerticalDrag: true,
      escKey: true,
      arrowKeys: true,
      trapFocus: true,
      returnFocus: true,
      closeTitle: 'Luk',
      zoomTitle: 'Zoom ind eller ud',
      arrowPrevTitle: 'Forrige billede',
      arrowNextTitle: 'Næste billede',
      indexIndicatorSep: ' af ',
      errorMsg: 'Billedet kunne ikke indlæses',
      imageClickAction: 'zoom',
      tapAction: 'toggle-controls',
      doubleTapAction: 'zoom',
      preload: [1, 2],
      initialZoomLevel: 'fit',
      secondaryZoomLevel: function (zoomLevel) {
        return Math.min(1, Math.max(zoomLevel.fill, zoomLevel.fit * 2.5));
      },
      maxZoomLevel: function (zoomLevel) {
        return Math.min(2, Math.max(1, zoomLevel.fit * 4));
      },
      paddingFn: function (viewportSize) {
        var compact = viewportSize.x < 750;
        return {
          top: compact ? 64 : 36,
          bottom: compact ? 16 : 36,
          left: compact ? 8 : 72,
          right: compact ? 8 : 72
        };
      }
    });

    lightbox.on('beforeOpen', function () {
      root.dataset.emeZoomOpen = 'true';
      lastViewedMediaIndex = null;
      if (document.activeElement && document.activeElement.matches(OPENER_SELECTOR)) {
        lastOpener = document.activeElement;
      }
    });

    lightbox.on('afterInit', function () {
      var viewer = lightbox.pswp && lightbox.pswp.element;
      if (!viewer) return;
      document.documentElement.classList.add('eme-pswp-open');
      setBackgroundInert(viewer);
      viewer.addEventListener('keydown', trapFocus);
      requestAnimationFrame(function () {
        viewer.querySelector('.pswp__button--close')?.focus({ preventScroll: true });
      });
    });

    lightbox.on('openingAnimationEnd', function () {
      lightbox.pswp?.element?.querySelector('.pswp__button--close')?.focus({ preventScroll: true });
    });

    lightbox.on('change', function () {
      lastViewedMediaIndex = mediaIndexFromSlide(lightbox.pswp && lightbox.pswp.currSlide);
    });

    lightbox.on('close', function () {
      root.dataset.emeZoomOpen = 'false';
    });

    lightbox.on('destroy', function () {
      var viewer = lightbox.pswp && lightbox.pswp.element;
      viewer?.removeEventListener('keydown', trapFocus);
      restoreBackground();
      syncProductGallery(root, lastViewedMediaIndex);
      requestAnimationFrame(function () {
        if (lastOpener && lastOpener.isConnected) lastOpener.focus({ preventScroll: true });
      });
    });

    lightbox.init();
    root._emeZoomLightbox = lightbox;
    root._emeZoomRememberOpener = rememberOpener;
    root.dataset.emeZoomReady = 'true';
  }

  function initializeAll(scope) {
    var roots = [];
    if (scope && scope.matches && scope.matches(ROOT_SELECTOR)) roots.push(scope);
    if (scope && scope.querySelectorAll) roots = roots.concat(Array.from(scope.querySelectorAll(ROOT_SELECTOR)));
    roots.forEach(initialize);
  }

  function boot() {
    initializeAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target || !event.target.querySelectorAll) return;
    event.target.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      if (root._emeZoomRememberOpener) root.removeEventListener('click', root._emeZoomRememberOpener, true);
      if (root._emeZoomLightbox) root._emeZoomLightbox.destroy();
      delete root._emeZoomLightbox;
      delete root._emeZoomRememberOpener;
    });
  });
})();
